import { clearDashboardCache } from './dashboardCache';

export const APP_BUILD_ID_KEY = 'smartnet_admin_build_id';
const RELOAD_GUARD_KEY = 'smartnet_client_reload_guard';

const readBuildId = () =>
  String(
    process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA ||
      process.env.REACT_APP_BUILD_ID ||
      process.env.REACT_APP_VERSION ||
      'dev',
  ).trim();

export const getCurrentBuildId = () => readBuildId();

const chunkErrorPatterns = [
  /loading chunk/i,
  /chunkloaderror/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
];

export const isChunkLoadError = (value) => {
  const text = String(value?.message || value || '');
  return chunkErrorPatterns.some((pattern) => pattern.test(text));
};

export const shouldRecoverStaleClient = (error) => isChunkLoadError(error);

export const notifyUpdateAvailable = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('smartnet:update-available'));
};

export const clearClientStorage = async () => {
  try {
    if (typeof localStorage !== 'undefined') localStorage.clear();
    if (typeof sessionStorage !== 'undefined') sessionStorage.clear();
  } catch {
    /* silent */
  }
  await clearDashboardCache();
};

export const clearClientStorageAndReload = async () => {
  if (typeof window === 'undefined') return;
  if (sessionStorage.getItem(RELOAD_GUARD_KEY) === '1') {
    notifyUpdateAvailable();
    return;
  }

  const buildId = getCurrentBuildId();
  await clearClientStorage();

  try {
    sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
    localStorage.setItem(APP_BUILD_ID_KEY, buildId);
  } catch {
    /* silent */
  }

  window.location.reload();
};

/** Al arrancar: si el acceso directo trae JS viejo, limpia storage y recarga una vez. */
export const syncAppBuildVersion = () => {
  if (typeof window === 'undefined') return;

  const current = getCurrentBuildId();
  let stored = null;
  try {
    stored = localStorage.getItem(APP_BUILD_ID_KEY);
  } catch {
    stored = null;
  }

  if (!stored) {
    try {
      localStorage.setItem(APP_BUILD_ID_KEY, current);
    } catch {
      /* silent */
    }
    return;
  }

  if (stored !== current) {
    void clearClientStorageAndReload();
  }
};

export const registerStaleClientListeners = () => {
  if (typeof window === 'undefined') return undefined;

  const onError = (event) => {
    if (isChunkLoadError(event?.message || event?.error)) {
      notifyUpdateAvailable();
    }
  };

  const onRejection = (event) => {
    if (isChunkLoadError(event?.reason)) {
      notifyUpdateAvailable();
    }
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
};
